import React from 'react';
import PropTypes from 'prop-types';
//import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import {TweenLite, Elastic, Bounce} from 'gsap';
import gsap from 'gsap-react-plugin';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appDataActions from '../../../actions/appDataActions';
import * as dialogPopupActions from '../../../actions/dialogPopupActions';
import * as appHelper from '../../../helpers/appHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as dataHelper from '../../../helpers/dataHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as keyboardConstants from '../../../constants/keyboardConstants';

//import toastr from 'toastr';

export class ScreenDialog extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
			screenDialog: this.props.screenDialog,
            userData: this.props.userData,
            currentOpacity: 0,
            currentTop: 0,
            isOpenOpacity: 1,
            isOpenTop: 0,
            isClosedOpacity: 0,
            isClosedTop: 0,
            assetViewed: false,
            config: this.props.screenDialog.config,
            //locale: appHelper.getLocalData(this.props.screenDialog.config.screen),
            parentScreen: appHelper.getScreenData(
                {
                    bite_id: this.props.screenDialog.config.biteCallbacks.getBiteId(),
                    screen_id: this.props.screenDialog.config.parentScreen.screen_id
                }
            ),
            screen: appHelper.getSubScreen(
                {
                    bite_id: this.props.screenDialog.config.biteCallbacks.getBiteId(),
                    parent_screen_id: this.props.screenDialog.config.parentScreen.screen_id,
                    screen_id: this.props.screenDialog.config.screen.screen_id
                }
            ),
            tabbableElements: [],
            isOpen: false,
            elementInterval: {},
            guid: dataHelper.createGuid(),
            label: appHelper.getLocaleString("done_label"),
            close_label: appHelper.getLocaleString("close_label"),
            locale: {}
        };
        this.openDialog = this.openDialog.bind(this);
        this.isOpenFunc = this.isOpenFunc.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
        this.isClosedFunc = this.isClosedFunc.bind(this);
        this.onAssetViewed = this.onAssetViewed.bind(this);
        this.getStatus = this.getStatus.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.setTabbableElements = this.setTabbableElements.bind(this);
        this.setTabbedInterval = this.setTabbedInterval.bind(this);
        //this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.setInitialFocus = this.setInitialFocus.bind(this);
        this.getLocale();
    }

    componentDidMount() {
        window.addEventListener("keydown", this.onKeyDown);
        window.addEventListener("keyup", this.onKeyUp);
        this.getLocale();
       this.setTabbedInterval();

        let func =  this.openDialog;
        setTimeout(function(){

            func();
        },200);

    }

    componentWillReceiveProps(nextProps) {
        if(this.state.userData !== nextProps.userData){
            this.setState({
                userData: Object.assign({},nextProps.userData)
            });
        }
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screen),
                label: appHelper.getLocaleString("done_label"),
                close_label: appHelper.getLocaleString("close_label"),
            });
        }
    }

    componentDidUpdate(){
       /* if (!this.state.isOpen && this.state.screenDialog.isOpen) {
            this.setInitialFocus();
        }*/
    }

    componentWillUnmount(){
        window.removeEventListener("keydown", this.onKeyDown);
        window.removeEventListener("keyup", this.onKeyUp);
        clearInterval(this.state.elementInterval);
    }

    getLocale(){
        this.setState({

            locale: appHelper.getLocalData(this.state.screen),

        });
    }

    setTabbedInterval(){
        let interval = setInterval(this.setTabbableElements, 2000);
        this.setState({elementInterval: interval});
    }

    openDialog() {
        if(appHelper.isDefined(this) && this !== null) {
            TweenLite.to(this, objectConstants.DIALOG_DURATION, {
                state: {
                    currentOpacity: this.state.isOpenOpacity,
                    currentTop: this.state.isOpenTop
                }
            }).eventCallback("onComplete", this.isOpenFunc);
        }
    }

    isOpenFunc(){
        this.setState(
            {screenDialog: Object.assign({}, this.state.screenDialog,{
                isOpen: true,
                currentClassState: this.state.screenDialog.classStates.isOpen
            })}
        );
    }

    closeDialog() {
        let focusEl = document.getElementById(this.state.screenDialog.config.sourceId);

        if(appHelper.isDefined(focusEl) && focusEl !== null){
            focusEl.focus();
        }
        this.setState(
            {
                screenDialog: Object.assign({}, this.state.screenDialog, {
                    isOpen: false,
                    currentClassState: this.state.screenDialog.classStates.isClosed
                })
            }
        );
        if(appHelper.isDefined(this) && this !== null) {
            TweenLite.to(this, objectConstants.DIALOG_DURATION, {
                state: {
                    currentOpacity: this.state.isClosedOpacity,
                    currentTop: this.state.isClosedTop
                }, delay: 0.5
            }).eventCallback("onComplete", this.isClosedFunc);
        }
    }

    isClosedFunc(){
        this.props.actions.removeScreenDialog();
        this.state.screenDialog.config.onClose(this.state.assetViewed);

    }

    onAssetViewed(){
        this.setState({assetViewed: true});
    }


    setAccessibleExit(event){
        if(event.which === keyboardConstants.ESCAPE_KEY){
            event.preventDefault();
            this.closeDialog();
        }
    }

    getStatus(){

        let screenUserData = userDataHelper.getSubScreenUserData(this.state.userData, this.state.config.parentScreen.screen_id,this.state.screen.screen_id);
        if (screenUserData.status === objectConstants.STATUS_NOT_STARTED) {
            return "not-started";
        } else if (screenUserData.status === objectConstants.STATUS_IN_PROGRESS) {
            return "in-progress";
        } else if (screenUserData.status === objectConstants.STATUS_COMPLETE) {
            return "complete";
        } else if (screenUserData.status === objectConstants.STATUS_NOT_REQUIRED) {
            return "not-required";
        }

    }

    onKeyDown(event) {
        let shiftPressed = this.state.shiftPressed;
        let tabPressed = this.state.tabPressed;

        if (event.which === keyboardConstants.ESCAPE_KEY) {
            event.preventDefault();
            this.closeDialog();
        }

        if (event.which === keyboardConstants.TAB_KEY) {

            tabPressed = true;
            this.setState({
                tabPressed: tabPressed
            });
        }

        if (event.which === keyboardConstants.SHIFT_KEY) {
            shiftPressed = true;
            this.setState({
                shiftPressed: shiftPressed
            });
        }
    }

    onKeyUp(event) {
        let activeItem = document.activeElement;
        let activeItemId = activeItem.id;
        //console.log(activeItemId);
        if (activeItemId === this.state.tabbableElements[0].id) {
            //go to last
            //console.log(this.state.tabbableElements[this.state.tabbableElements.length - 2]);
            this.state.tabbableElements[this.state.tabbableElements.length - 2].focus();
        } else if (activeItemId === this.state.tabbableElements[this.state.tabbableElements.length - 1].id) {
            this.state.tabbableElements[1].focus();
        }

        this.setState({
            tabPressed: false,
            shiftPressed: false
        });
    }


    setTabbableElements() {
        let dialog = this.refs.screenDialog;
        let tabbableElements = dataHelper.getAllTabbableElements(dialog);
        this.setState({tabbableElements: Object.assign([], dataHelper.getAllTabbableElements(dialog))});
        if (!this.state.isOpen && this.state.screenDialog.isOpen) {
            this.setInitialFocus();
        }
    }

    setInitialFocus() {
        let initFocusEl = this.state.tabbableElements[1];
        if (appHelper.isDefined(initFocusEl)) {
            this.state.tabbableElements[1].focus();
            this.setState({isOpen: true});
        }
    }

    render() {
        let config = this.state.screenDialog.config;
        let Component = config.component;

        return (

            <div className={`dialog-page ${this.state.screenDialog.currentClassState}`} style={{opacity: this.state.currentOpacity }} ref="screenDialog" id="screenDialog" role="dialog" >
                <div id={`firstTabIndex_screenDialog_${this.state.guid}`} tabIndex="0" role="button"/>
                <div className={`${this.state.screenDialog.className} ${this.state.screen.hotspot_layout_type}`}>
                    <div className="dialog-header" role="button" tabIndex={this.getStatus() === "complete" || this.getStatus() === "not-required" ? -1 : 0}>
                        <div className="title-col">
                            <div className={`title ${this.getStatus()}`} dangerouslySetInnerHTML={{__html: this.state.locale.title}}/>
                        </div>
                        <div className="nav-col">
                            {
                                this.getStatus() === "complete" || this.getStatus() === "not-required"
                                ?
                                    <button className={`btn guroo-btn`} onClick={this.closeDialog}>{this.state.label}</button>
                                :
                                    <button className={`btn guroo-btn`} onClick={this.closeDialog}>{this.state.close_label}</button>
                            }
                        </div>
                    </div>
                    <div className={`dialog-body ${this.state.screenDialog.config.screen.screen_type_code}`}>
                        <Component screen={this.state.screen} parentScreen={this.state.parentScreen} biteCallbacks={config.biteCallbacks} closeDialog={this.closeDialog}/>
                    </div>
                </div>
                <div id={`lastTabIndex_screenDialog_${this.state.guid}`} tabIndex="0" role="button"/>
            </div>
        );

    }
}

ScreenDialog.propTypes = {
    screenDialog: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

//Pull in the React Router context so router is available on this.context.router.
ScreenDialog.contextTypes = {
    router: PropTypes.object
};

//Init
function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        screenDialog: state.screenDialog,
        userData: state.userData,
        lang:lang
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ScreenDialog);



/** WEBPACK FOOTER **
 ** ./src/components/dialogs/screenDialog/ScreenDialog.js
 **/